<template>
  <div class="cont-filter" :style="styleColor">
    <a-select
      v-model="accountIds"
      mode="multiple"
      :filter-option="false"
      :maxTagCount="1"
      :maxTagTextLength="6"
      placeholder="请选择也支持关键字搜索"
      @change="changeAccount"
      @search="handleSearchAccount"
    >
      <a-select-option
        v-for="item in accountList"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getDataAccount,
  getDataDimension
} from "@/api/basicCyberData";
export default {
  name: "widgetFilter",
  props: {
    value: Object,
    ispreview: Boolean
  },
  data() {
    return {
      options: {
      },
      openFlag: false,
      accountIds: [],
      accountList: [],
      filterType: undefined,
      datasource: undefined,
      
    };
  },
  computed: {
    ...mapGetters({
      globalOptions: "globalOptions",
    }),
    transStyle() {
      console.log(this.$objToOne(this.options));
      return this.$objToOne(this.options);
    },
    styleColor() {
      return {
        position: this.ispreview ? "absolute" : "static",
        color: this.transStyle.color || "#fff",
        value: this.transStyle.value || [],
        timeSelector: this.transStyle.timeSelector,
        "font-size": this.transStyle.fontSize + "px" || "30px",
        "letter-spacing": this.transStyle.letterSpacing + "em",
        background: this.transStyle.background,
        "font-weight": this.transStyle.fontWeight,
        "text-align": this.transStyle.textAlign,
        display:
          this.transStyle.hideLayer == undefined
            ? "block"
            : this.transStyle.hideLayer
            ? "none"
            : "block",
        width: this.transStyle.width + "px",
        height: this.transStyle.height + "px",
        left: this.transStyle.left + "px",
        top: this.transStyle.top + "px",
        right: this.transStyle.right + "px"
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.$nextTick(()=>{
          this.options = this.$deepclone(val);
          this.setOptionsData();
        })
        console.log(val, 'widget-filter-value')
      },
      deep: true
    },
  },
  mounted() {
    // this.options = this.value;
    console.log(this.options)
  },
  methods: {
    async setOptionsData(){
      const options = this.options.data.dynamicData.contextData
      console.log(options, 'widget-filter-setOptionsData')
      const accountIds = this.options.data && options ? options.accountIds : []
      this.datasource = this.options.data && options ? options.datasource : {};
      this.filterType = this.options.data && options ? options.filterType : '';
      if(accountIds && accountIds.length > 0){
        await this.handleSearchAccount('', [...accountIds])
      }
      this.accountIds = accountIds
    },
    changeAccount(val){
      if(this.ispreview){
        const accountIds = this.$deepclone(this.accountIds)
        const globalOptions = { 
          globalDataSource: this.datasource, 
          globalAccountIds: accountIds, 
          globalFilterType: this.filterType
        }
        this.$emit('changeOptions', globalOptions)
        this.$store.commit("modelDesign/SET_GLOBAL_OPTIONS", globalOptions)
      }
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    handleSearchAccount(val, orderAccountIds = {}) {
      this.fetchAcccount(val, orderAccountIds);
    },
    fetchAcccount(val, orderAccountIds) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getAcccountList(val, orderAccountIds);
      }, 500);
    },
    async getAcccountList(keyWord, orderAccountIds) {
      const params = {
        mediaCode: this.datasource.mediaCode,
        authType: this.filterType
      };
      const dataParams = {
        filterEnable: true,
        searchKeyWord: keyWord,
        orderAccountIds,
      };
      const { code, data } = await getDataDimension(params, dataParams);
      this.accountList = data ? data.recordList : [];
      if (code != 200) return;
    },
  }
};
</script>
<style lang="less" scoped>
.cont-filter {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /deep/ .ant-select {
    width: 100%;
    height: 100%;
    vertical-align: top;
    font-size: inherit;
    // .ant-calendar-picker-input {
    //   height: 100%;
    //   font-size: inherit;
    //   .ant-calendar-range-picker-separator {
    //     vertical-align: inherit;
    //   }
    // }
  }
}
</style>